"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const SvgLogoDps = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "M12,0.5l-10,2.5l0,5.3c0,0.476 0.027,1.034 0.085,1.507c0.138,1.125 0.46,3.234 1.096,4.99c1.568,4.33 4.492,7.298 8.456,8.585l0.363,0.118l0.363,-0.118c3.964,-1.287 6.888,-4.255 8.456,-8.585c0.626,-1.73 0.949,-3.802 1.09,-4.939c0.06,-0.49 0.091,-1.064 0.091,-1.558l0,-5.3l-10,-2.5Zm8,7.841c0,0.419 -0.027,0.872 -0.077,1.272c-0.125,1.011 -0.419,2.941 -0.984,4.502c-1.315,3.634 -3.711,6.145 -6.938,7.278c-3.228,-1.134 -5.623,-3.645 -6.938,-7.277c-0.229,-0.632 -0.412,-1.322 -0.559,-1.99l7.496,1.874l-0,-2l-7.868,-1.967c-0.023,-0.17 -0.044,-0.329 -0.061,-0.468c-0.046,-0.372 -0.071,-0.806 -0.071,-1.224l-0,-0.341l8,2l-0,-2l-8,-2l-0,-1.45l8,-1.988l8,1.988l0,3.791Z" })));
exports.default = SvgLogoDps;
